import { ISlotsStatePersisted } from 'features/slots/types'

type ReturnMigrationType = (state: ISlotsStatePersisted) => ISlotsStatePersisted

export const slotsMigrations: Record<string, ReturnMigrationType> = {
  1: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  2: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  3: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  4: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  5: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
}
